import type { AuthFlow } from './types'

export function detectFlow(route: string, desiredPath?: string): AuthFlow {
  const target = desiredPath || route
  if (target.startsWith('/enroll')) return 'enroll'
  if (target.startsWith('/renewal')) return 'renewal'
  return 'unknown'
}

export function formatReason(err: unknown): string {
  const fallback = 'Unknown error'
  if (typeof err === 'object' && err !== null) {
    return typeof (err as Record<string, unknown>)['message'] === 'string'
      ? (err as { message: string }).message
      : fallback
  }
  return fallback
}

export function formatMeta(err: unknown): Record<string, string> {
  if (typeof err !== 'object' || !err) return {}
  const e = err as Record<string, unknown>
  const result: Record<string, string> = {}
  if (typeof e.message === 'string') result.message = e.message
  if (typeof e.stack === 'string') result.stack = e.stack
  if (e.status != null) result.status = String(e.status)
  return result
}
